const NULL_VALUE = 'NULL';

export const nullify = <T>(
  value: T | undefined | null,
): T | typeof NULL_VALUE => value || NULL_VALUE;

export const isNullified = <T>(value: T) => value === NULL_VALUE;
